import {createAction} from "@reduxjs/toolkit";
import {
  DONE,
  FAIL,
  FETCH, POST, SCREENING_EARLY_QUESTIONS_LIST, SCREENING_ONE_TEST, SCREENING_ONE_EARLY_TEST,SCREENING_TESTS_EARLY_LIST,
  SCREENING_TESTS_LIST, SCREENING_SURVEYS_TEST, SET
} from "../../constants"

export const fetchScreeningTestsListAction = createAction<any>(SCREENING_TESTS_LIST + FETCH);
export const fetchScreeningTestsListActionDone = createAction<any>(SCREENING_TESTS_LIST + FETCH + DONE);
export const fetchScreeningTestsListActionFail = createAction<any>(SCREENING_TESTS_LIST + FETCH + FAIL);

export const fetchScreeningEarlyTestsListAction = createAction<any>(SCREENING_TESTS_EARLY_LIST + FETCH);
export const fetchScreeningEarlyTestsListActionDone = createAction<any>(SCREENING_TESTS_EARLY_LIST + FETCH + DONE);
export const fetchScreeningEarlyTestsListActionFail = createAction<any>(SCREENING_TESTS_EARLY_LIST + FETCH + FAIL);

export const setOneTestAction = createAction<any>(SCREENING_TESTS_LIST + SET);
export const setOneEarlyTestAction = createAction<any>(SCREENING_TESTS_EARLY_LIST + SET);

export const fetchScreeningOneTestAction = createAction<any>(SCREENING_ONE_TEST + FETCH);
export const fetchScreeningOneTestActionDone = createAction<any>(SCREENING_ONE_TEST + FETCH + DONE);
export const fetchScreeningOneTestActionFail = createAction<null|undefined>(SCREENING_ONE_TEST + FETCH + FAIL);

export const postScreeningOneTestAction = createAction<any>(SCREENING_ONE_TEST + POST)
export const postScreeningOneTestActionDone = createAction<any>(SCREENING_ONE_TEST + POST + DONE)
export const postScreeningOneTestActionFail = createAction<null|undefined>(SCREENING_ONE_TEST + POST + FAIL)

export const postScreeningOneEarlyTestAction = createAction<any>(SCREENING_ONE_EARLY_TEST + POST)
export const postScreeningOneEarlyTestActionDone = createAction<any>(SCREENING_ONE_EARLY_TEST + POST + DONE)
export const postScreeningOneEarlyTestActionFail = createAction<null|undefined>(SCREENING_ONE_EARLY_TEST + POST + FAIL)

export const postScreeningEarlyQuestionsListAction = createAction<any>(SCREENING_EARLY_QUESTIONS_LIST + POST)
export const postScreeningEarlyQuestionsListActionDone = createAction<any>(SCREENING_EARLY_QUESTIONS_LIST + POST + DONE)
export const postScreeningEarlyQuestionsListActionFail = createAction<any>(SCREENING_EARLY_QUESTIONS_LIST + POST + FAIL)

export const fetchScreeningRoutinesListAction = createAction<any>(SCREENING_SURVEYS_TEST + FETCH);
export const fetchScreeningRoutinesListActionDone = createAction<any>(SCREENING_SURVEYS_TEST + FETCH + DONE);
export const fetchScreeningRoutinesListActionFail = createAction<null|undefined>(SCREENING_SURVEYS_TEST + FETCH + FAIL);
